<div class="alert-details-dialog">
  <div class="dialog-header">
    <div>Alert Details</div>
    <span class="ui-icon-close ui-icon-button no-border" (click)="close()"></span>
  </div>

  <div class="dialog-content">
    <!-- Alert Info -->
    <div class="alert-info-section">
      <div class="thumbnail-section">
        <img
          *ngIf="alert.mainThumbnail && !thumbnailLoadFailed"
          [appAuthSrc]="getThumbUrl(alert.mainThumbnail)"
          (authError)="onDialogThumbnailError()"
          (click)="openImagePreview(alert.mainThumbnail, $event)"
          alt=""
          class="dialog-thumbnail"
        />
        <div *ngIf="!alert.mainThumbnail || thumbnailLoadFailed" class="no-thumbnail">
          <mat-icon aria-hidden="true">hide_image</mat-icon>
        </div>
      </div>
      <div class="info-details">
        <div class="info-row">
          <span class="info-label">Alert ID:</span>
          <span class="info-value monospace">{{ alert.alertInstanceId }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Location:</span>
          <span class="info-value">{{ alert.locationName || alert.locationId }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Camera:</span>
          <span class="info-value">{{ alert.cameraName || alert.cameraId }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Time:</span>
          <span class="info-value">
            <ui-user-settings-date [date]="alert.timestamp" [timezone]="alert.timezone" [dateTypeFormat]="UiUserSettingsDateType.mdyTimeSec"></ui-user-settings-date>
          </span>
        </div>
        <div class="info-row" *ngIf="alert.alertMessage">
          <span class="info-label">Message:</span>
          <span class="info-value">{{ alert.alertMessage }}</span>
        </div>
      </div>
    </div>

    <!-- Tabs for Activity and Noonlight Logs -->
    <mat-tab-group class="logs-tabs">
      <mat-tab label="Activity Log">
        <div class="tab-content">
          <div *ngIf="isLoadingActivity" class="loading-state">
            <mat-spinner diameter="32"></mat-spinner>
            <span>Loading activity logs...</span>
          </div>
          <div *ngIf="!isLoadingActivity && activityLogs.length === 0" class="empty-state">
            <mat-icon>inbox</mat-icon>
            <span>No activity logs found</span>
          </div>
          <div *ngIf="!isLoadingActivity && activityLogs.length > 0" class="logs-list">
            <div *ngFor="let log of activityLogs" class="log-item">
              <div class="log-icon">
                <mat-icon>{{ getActionIcon(log.action) }}</mat-icon>
              </div>
              <div class="log-content">
                <div class="log-action">{{ getActionLabel(log.action) }}</div>
                <div class="log-time">
                  <ui-user-settings-date [date]="log.timestamp" [timezone]="alert.timezone" [dateTypeFormat]="UiUserSettingsDateType.mdyTimeSec"></ui-user-settings-date>
                </div>
                <div class="log-details" *ngIf="log.details">{{ log.details }}</div>
                <div class="log-user" *ngIf="log.email">By: {{ log.email }}</div>
                <div class="log-user" *ngIf="!log.email && log.userId">By: {{ log.userId }}</div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Noonlight Activity">
        <div class="tab-content">
          <div *ngIf="isLoadingNoonlight" class="loading-state">
            <mat-spinner diameter="32"></mat-spinner>
            <span>Loading Noonlight logs...</span>
          </div>
          <div *ngIf="!isLoadingNoonlight && noonlightLogs.length === 0" class="empty-state">
            <mat-icon>inbox</mat-icon>
            <span>No Noonlight activity found</span>
          </div>
          <div *ngIf="!isLoadingNoonlight && noonlightLogs.length > 0" class="logs-list">
            <div *ngFor="let log of noonlightLogs" class="log-item noonlight-log">
              <div class="log-icon" [ngClass]="log.operationType.includes('REQUEST') ? 'request' : 'response'">
                <mat-icon>{{ log.operationType.includes('REQUEST') ? 'arrow_forward' : 'arrow_back' }}</mat-icon>
              </div>
              <div class="log-content">
                <div class="log-action">{{ getOperationTypeLabel(log.operationType) }}</div>
                <div class="log-time">
                  <ui-user-settings-date [date]="log.requestTimestamp" [timezone]="log.timezone" [dateTypeFormat]="UiUserSettingsDateType.mdyTimeSec"></ui-user-settings-date>
                </div>
                <!-- For RESPONSE types: show result and verified -->
                <ng-container *ngIf="isResponseType(log.operationType)">
                  <div class="log-details" *ngIf="log.result">Result: {{ log.result }}</div>
                  <div class="log-details" *ngIf="log.verified !== undefined">Verified: {{ log.verified ? 'Yes' : 'No' }}</div>
                </ng-container>

                <!-- For REQUEST types: show prompt -->
                <ng-container *ngIf="isRequestType(log.operationType)">
                  <div class="log-details" *ngIf="log.prompt">Prompt: {{ log.prompt }}</div>
                </ng-container>

                <!-- Show for all types -->
                <div class="log-details" *ngIf="log.dispatchEventType">Event: {{ log.dispatchEventType }}</div>
                <div class="log-details" *ngIf="log.requestDurationMs">Duration: {{ log.requestDurationMs }}ms</div>
                <button *ngIf="log.attachmentUrl" (click)="openAttachment(log.attachmentUrl)" class="attachment-link">
                  <mat-icon>attachment</mat-icon> View Attachment
                </button>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <div class="dialog-actions">
    <ui-button type="primary" (click)="close()">Close</ui-button>
  </div>
</div>
